import React from "react";
import { useSelector } from "react-redux";
import { useParams, Navigate } from "react-router-dom";
import { selectUser } from "store/src/slices/auth-slice";
import EmployeeInfoCard from "components/employee/profile-card";
import { useFetch } from "@/hooks/useFetch";

import { getUserFields } from "components/user/config";
import Loader from "@/components/loader";
import HeaderPortal from "components/portal/header-portal";
import EditItemButton from "components/buttons/edit";
import { UserFieldInput } from "permissions/components/user-field-input";
import PendingIntegrationBanner from "components/my-profile/integrations/integration";
import { fetchEmployee } from "directus/src/operations";

export default function MyProfileAbout() {
  const { employeeId } = useParams();
  const currentUser = useSelector(selectUser);

  if (employeeId && currentUser?.id === employeeId) {
    return <Navigate to="/profile/about" replace />;
  }

  const fields = [
    "id",
    ...getUserFields(),
    getUserFields("reports_to"),
    "secondary_job_title",
    "discord_user_id",
    "github_username",
    "email",
    "phone_no",
    "grade.name",
    "employee_id",
    "function.name",
    "job_title.name",
    "department.id",
  ];

  const {
    data: fetchedUser,
    isLoading,
    error,
  } = useFetch({
    queryKey: ["user", "prfoile", employeeId],
    queryFn: () => fetchEmployee(employeeId, { fields }),
    enabled: !!employeeId,
  });

  const user = employeeId ? fetchedUser : currentUser;

  if (employeeId && isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex-1">
      <PendingIntegrationBanner />
      <EmployeeInfoCard user={user} />
      <HeaderPortal>
        <UserFieldInput
          targetItem={user.id}
          field="avatar"
          collection="employees"
        >
          <EditItemButton href={`/organization/employees/${user.id}/edit`} />
        </UserFieldInput>
      </HeaderPortal>
    </div>
  );
}
